/* globals translation */
( 'use strict' );

require('./quantity');
require('./popup');
require('./mini-cart');

jQuery(($) => {

	/*
		Show/hide coupon field
	*/

	$(document).on('click', '.showcoupon', (e) => {
		e.preventDefault();
		$('.hidden-coupon-fields').slideToggle(500);
	});


	/*
		Footer widgets accordion functionality
	*/

	const widgetTitle = $('.suki-footer-widgets-bar-row .suki-footer-widgets-bar-column-2 .widget_text > .widget-title, .suki-footer-widgets-bar-row .suki-footer-widgets-bar-column-3 .widget_nav_menu > .widget-title');
	widgetTitle.each(function filterTitleEach() {
		if ($(this).parent().find('.chosen').length > 0) {
			$(this).addClass('active');
			$(this).parent().find('ul').show();
			$(this).parent().find('.textwidget').show();
		}
		$(this).on('click', (e) => {
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).parent().find('ul').slideToggle();
			$(this).parent().find('.textwidget').slideToggle();
		});
	});


	/*
		Mobile mega menu functionality
	*/

	$('#menu-hovedmeny > li.menu-item-has-children > a').append('<span class="toggle-sub"><img src="' + translation.templateUrl + '/assets/images/pluss.svg"/></span>');
	$('#menu-hovedmeny ul.sub-menu > li.menu-item-has-children > a').append('<span class="toggle-sub"><img src="' + translation.templateUrl + '/assets/images/pluss.svg"/></span>');

	$('#menu-hovedmeny li ul').each(function () {
		// $(this).children(":first").addClass('active');
		// $(this).children(":first").children(":last").addClass('sub-opened');
		$(this).children(":not(:first-child)").on('click', () => {
			$(this).children(":first").removeClass('active');
		});
	})

	$('.suki-header-mobile-vertical-bar-top  #menu-primary-menu > li.menu-item-has-children > a').append('<span class="toggle-sub"><img src="' + translation.templateUrl + '/assets/images/pluss.svg"/></span>');
	$('.suki-header-mobile-vertical-bar-top  #menu-primary-menu ul.sub-menu > li.menu-item-has-children > a').append('<span class="toggle-sub"><img src="' + translation.templateUrl + '/assets/images/pluss.svg"/></span>');

	$('.suki-header-mobile-vertical-bar-top  #menu-primary-menu li ul').each(function () {
		// $(this).children(":first").addClass('active');
		// $(this).children(":first").children(":last").addClass('sub-opened');
		$(this).children(":not(:first-child)").on('click', () => {
			$(this).children(":first").removeClass('active');
		});
	})

	const mobileMenuToggle = $('span.toggle-sub');
	mobileMenuToggle.each(function () {
		$(this).on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass('opened');
			$(this).parent().siblings('.sub-menu').toggleClass('opened').parent().siblings().find('.sub-menu').removeClass('opened').siblings('a.suki-menu-item-link').find('.toggle-sub').removeClass('opened');
		});
	});

	const mobileSubMenuToggle = $('#menu-hovedmeny li ul li.menu-item-has-children');
	mobileSubMenuToggle.each(function () {
		$(this).find('span.toggle-sub').on('click', function (e) {
			e.preventDefault();
			$(this).parent().parent().toggleClass('active').siblings().removeClass('active');
			$(this).parent().parent().find('.sub-menu').toggleClass('sub-opened').parent().siblings().find('.sub-menu').removeClass('sub-opened');;
		});
	});

	const mobileSubMenuToggleEn = $('.suki-header-mobile-vertical-bar-top  #menu-primary-menu li ul li.menu-item-has-children');
	mobileSubMenuToggleEn.each(function () {
		$(this).find('span.toggle-sub').on('click', function (e) {
			e.preventDefault();
			$(this).parent().parent().toggleClass('active').siblings().removeClass('active');
			$(this).parent().parent().find('.sub-menu').toggleClass('sub-opened').parent().siblings().find('.sub-menu').removeClass('sub-opened');;
		});
	});
	/*
		Functionality for jet-tabs (mega-menu tabs)
	*/

	function tabsHandler() {
		const tabs = document.querySelector('.jet-tabs__control-wrapper');
		if (!tabs) {
			return;
		}
		const fadeOut = (el) => {
			el.style.opacity = 0;
			setTimeout(() => {
				el.style.display = 'none';
				el.style.opacity = '0';
				el.style.position = 'absolute';
			}, 350);
		};
		const fadeIn = (el) => {
			el.style.opacity = 1;
			setTimeout(() => {
				el.style.display = 'block';
				el.style.opacity = '1';
				el.style.position = 'relative';
			}, 350);
		};
		const markActiveTabsContent = (tabsContentElements, index) => {
			tabsContentElements.forEach((el, i) => {
				fadeOut(el);
				if (i + 1 === index) {
					fadeIn(el);
				}
			});
		};
		const markActiveTabsLi = (tabsLiElements, index) => {
			tabsLiElements.forEach((el, i) => {
				el.classList.remove('active-tab');
				if (i + 1 === index) {
					fadeIn(el);
					el.classList.add('active-tab');
				}
			});
		};
		const tabsContentElements = document.querySelector('.jet-tabs__content-wrapper').children;
		tabs.addEventListener('click', (e) => {
			const { target } = e;
			if (target.classList.contains('jet-tabs__control')) {
				const index = parseInt(target.dataset.tab);
				markActiveTabsContent(tabsContentElements, index);
				markActiveTabsLi(tabs.children, index);
			}
		});

	}
	tabsHandler();


	/* Adding class for active category in sidebar */

	const activeurl = window.location;
	$(`ul.post-categories li a[href="${activeurl}"]`).addClass('active');


	/*
		Mega menu functioanlity
	*/

	const megaMenuUl = $('ul.suki-hover-menu li:not(.maksimer-mega-menu-link) > ul.sub-menu li > ul');

	const subMenu = $('ul.sub-menu');
	subMenu.each(function () {
		$(this).removeClass('suki-sub-menu-right');
	});

	const megaMenuFirstLevel = $('ul.suki-hover-menu li.menu-item-has-children:not(.maksimer-mega-menu-link)');
	megaMenuFirstLevel.each(function () {

		$(this).on('click', (event) => {
			event.stopPropagation();
			$(this).toggleClass('active').siblings().removeClass('active');
			$(this).siblings().find('li.active').removeClass('active');
			$(this).find('.sub-menu:first').children(":first").addClass('active');
			$(this).find('.sub-menu:first').children(":not(:first-child)").on('click', () => {
				$(this).find('.sub-menu:first').children(":first").removeClass('active');
			});

			$(this).find('.sub-menu:first').toggleClass('active-ul').parent().siblings().find('.sub-menu').removeClass('active-ul');
		});

	} );
	const megaMenuSecondLevel = $('ul.suki-hover-menu li:not(.maksimer-mega-menu-link) > ul.sub-menu li.maksimer-mega-menu-img > a');
	megaMenuSecondLevel.each(function () {
		$(this).on('click', (e) => {
			e.preventDefault();
		});
	} );
	$('.unbind-click > a').each(function () {
		$(this).on('click', (e) => {
			e.preventDefault();
		});
	})


	/*
		Functionality of custom gutenberg testimonials block
	*/

	function testimonials() {
		var slideCount = $("#slider ul li").length;
		let slideWidth;
		let slideHeight = $("#slider ul li").height();
		if ($(window).width() < 1024) {
			slideWidth = (80 / 100) * $(window).width();
			$("#slider ul li").css("width", slideWidth);
		} else {
			$("#slider ul li").css("width", "786px");
			slideWidth = $("#slider ul li").width();
		}
		var sliderUlWidth = slideCount * slideWidth;
		$("#slider ul").css({ width: sliderUlWidth, marginLeft: -slideWidth });
		$("#slider ul li:last-child").prependTo("#slider ul");
		return slideWidth;
	}
	let testimonial = testimonials();
	function moveLeft() {
		$("#slider ul").animate(
			{
				left: +testimonial,
			},
			200,
			function () {
				$("#slider ul li:last-child").prependTo("#slider ul");
				$("#slider ul").css("left", "");
			}
		);
		$("#slider").css({ width:  $("#slider ul li").width(), height:  $("#slider ul li").height() });
	}
	function moveRight() {
		$("#slider ul").animate(
			{
				left: -testimonial,
			},
			200,
			function () {
				$("#slider ul li:first-child").appendTo("#slider ul");
				$("#slider ul").css("left", "");
			}
		);
		$("#slider").css({ width: $("#slider ul li").width(), height:  $("#slider ul li").height() });
	}
	$("a.control_prev").click(function () {
		moveLeft();
	});
	$("a.control_next").click(function () {
		moveRight();
	});
	$(document).ready(function () {
		testimonials();
		$(window).resize(function () {
			testimonials();
			$("#slider").css({ width: $("#slider ul li").width(), height:  $("#slider ul li").height() });
		});
	});

	/*
		Adding span "Jamax" begore each product title
	*/

	function productTitleWrapper() {
		let singleProductTitles = document.querySelectorAll(
			'h1.product_title.entry-title'
		);
		let loopProductTitles = document.querySelectorAll(
			'.suki-product-wrapper > a.woocommerce-loop-product__link'
		);
		let carouselTitles = document.querySelectorAll('.uael-loop-product__link');
		let wooProdBlockTitles = document.querySelectorAll('.title-link');

		if ( singleProductTitles ) {
			singleProductTitles.forEach( ( singleProductTitle ) => {
				singleProductTitle.innerHTML = singleProductTitle.innerHTML.replace (/^/,'<span>Jamax </span>');
			})
		}
		if ( loopProductTitles ) {
			loopProductTitles.forEach( ( loopProductTitle ) => {
				loopProductTitle.innerHTML = loopProductTitle.innerHTML.replace(/^/, '<span>Jamax </span>');
			})
		}
		if ( carouselTitles ) {
			carouselTitles.forEach( ( carouselTitle ) => {
				carouselTitle.innerHTML = carouselTitle.innerHTML.replace(/^/, '<span>Jamax </span>');
			})
		}
		if ( wooProdBlockTitles ) {
			wooProdBlockTitles.forEach( ( wooProdBlockTitle ) => {
				wooProdBlockTitle.innerHTML = wooProdBlockTitle.innerHTML.replace(/^/, '<span>Jamax </span>');
			})
		}
	}
	productTitleWrapper();

	function changeSearchTitle() {
		const searchTitle = jQuery('body.search .suki-page-header-title');
		const searchNoResult = jQuery('section.no-results.not-found .page-content > p');
		if (  searchTitle.length ) {
			searchTitle.contents()[0].nodeValue = 'Søkeresultater for: ';
		}
		if (  searchNoResult.length ) {
			searchNoResult.contents()[0].nodeValue = 'Beklager, men ingenting samsvarte med søkeordene dine. Prøv igjen med noen forskjellige nøkkelord.';
		}
	}
	changeSearchTitle();

	function changeGDPRtext() {
		const gdprPrivacy = jQuery('button.gdpr-preferences');
		const gdprButton = jQuery('button.gdpr-agreement');
		if ( gdprPrivacy.length ) {
			gdprPrivacy.contents()[0].nodeValue = 'Personvernpreferanser';
			gdprButton.contents()[0].nodeValue = 'Jeg er enig';
		}
	}
	changeGDPRtext();

	jQuery(document).on('click', 'a[href$=".pdf"]', function() {
		jQuery(this).attr('target', "_blank");
	});
});


/*
	Pre-load of main video on home page
*/

jQuery(($) => {
	//video_lazyloader();
});


function addSourceToVideo(element, src, type) {
	var source = document.createElement('source');

	source.src = src;
	source.type = type;

	element.appendChild(source);
}

function video_lazyloader() {
	const videoHolder = document.createElement('div');
	videoHolder.classList.add('elementor-background-video-container');
	const video = document.createElement('video');
	const wrapper = document.querySelector('#page-1235 .elementor-section-wrap > .elementor-section');

	video.classList.add('elementor-background-video-hosted', 'elementor-html5-video');
	addSourceToVideo(video, translation.templateUrl + 'https://www.jamax.no/content/uploads/2021/05/Jamax_himmel_forsidevideo_low.mp4', 'video/mp4');

	video.autoplay = true;
	video.controls = true;
	video.loop = true;
	video.muted = true;

	videoHolder.append(video);
	video.load();
	video.play();

	if (wrapper) {
		wrapper.prepend(videoHolder);
	}
}

document.addEventListener( 'wpcf7mailsent', function( event ) {
	const location = window.location.origin + '/thank-you-for-your-request/';
	window.location.href = location;
}, false );



const maksimer = {
	changeSearhInputPlaceholder: () => {
		const searchInputs = document.querySelectorAll(
			'form.search-form label > input.search-field'
		);
		if ( searchInputs ) {
			searchInputs.forEach( ( searchInput ) => {
				searchInput.placeholder = 'Search for product';
			});
		}
	},
	changePriceWidth: () => {
		const prices = document.querySelectorAll('li.product .quantity');
		if ( prices ) {
			prices.forEach( ( price ) => {
				price.parentElement.classList.add('one-row');
			});
		}
	},
	checkoutB2bRadio: () => {
		const btns = document.querySelectorAll('#maksimer_radio_buttons input');
		if (!btns) return;
		btns.forEach(btn => {
			if (btn.checked === true) {
				btn.parentNode.classList.add('checked');
			}
			btn.addEventListener('click', () => {
				btn.parentNode.parentNode.querySelector('.checked').classList.remove('checked');
				btn.parentNode.classList.add('checked');
			});
		});
	}
};
maksimer.changeSearhInputPlaceholder();
maksimer.changePriceWidth();
maksimer.checkoutB2bRadio();

jQuery(($) => {
	$('body').on('keyup change', '.results-container .result-row-product .quantity input', function (e) {
		const button = $(this).parents('.result-row-product').find('a.button');
		const min = $(this).attr('min');
		if (!$(this).val()) {
			button.addClass('disabled');
		} else {
			button.removeClass('disabled');
		}
		if (typeof this.checkValidity === 'function' && this.checkValidity()) {
			button.attr('data-quantity', $(this).val());
		} else {
			$(this).val(min);
			button.attr('data-quantity', min);
		}
	});
});


/**
 * Replaces the cart shipping destination string to only show the postcode.
 * @returns
 */
const maksimerCartHideShippingMunicipality = () => {
	let destination = document.querySelector('.woocommerce-shipping-destination > strong');
	if (!destination) {
		return;
	}

	const destinationSplit = destination.textContent.replace(',', '').split(' ');
	destinationSplit.forEach((string) => {
		const value = string.replace(',', '');
		let isNum = /^\d+$/.test(value);
		if (!isNum) {
			return;
		}
		destination.textContent = value;
	});
}

maksimerCartHideShippingMunicipality();

jQuery(document).on('updated_cart_totals', () => {
	maksimerCartHideShippingMunicipality();
});



/**
 * Prevents enter key press when on organization checkout field.
 */
const maksimerCheckoutPreventSubmit = () => {
	const organizationInput = document.querySelector('#billing_orgnr');
	if (!organizationInput) {
		return;
	}

	organizationInput.addEventListener('keypress', (e) => {
		if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
			e.preventDefault();
            document.querySelector('.maksimer-org-details').click();
        }
	});
}

maksimerCheckoutPreventSubmit();

jQuery(($) => {
	$('.suki-header-main .suki-header-main-bar-right button.suki-sub-menu-toggle').on('click', () => {
		console.log(document.querySelector('.suki-header-main form.woocommerce-product-search input.search-field'));
		setTimeout(function() {
			$('.suki-header-main form.woocommerce-product-search input.search-field').get(0).select();
		},200);
	});
});
jQuery(($) => {
	$('.suki-header-main form.woocommerce-product-search').on('click', (e) => {
		e.stopPropagation();
	});
});
